import styled from "styled-components";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ListItem, ListItemButton } from "@mui/material";

export const ListStyled = styled(List)`
  width: 180px;
`;

export const ListItemStyled = styled(ListItemButton)`
  padding: 0.5rem 1rem;
`;

export const ListItemIconStyled = styled(ListItemIcon)`
  .MuiSvgIcon-root {
    width: 1rem;
    height: 1rem;
  }
`;

export const ListItemTextStyled = styled(ListItemText)`
  .MuiListItemText-root {
    font-size: 1rem;
  }
`;
